import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { languageSelector } from 'i18n/selectors'

import BookingDetails from 'shared/components/BookingDetails'
import { clearGuestReservationsState } from 'manage-guest-user-booking/actions'
import { guestUserReservationsSelector } from 'manage-guest-user-booking/selectors'

const GuestBookingDetails = () => {
    const dispatch = useDispatch()
    const history = useHistory()

    const language = useSelector(languageSelector)
    const reservation = useSelector(guestUserReservationsSelector)

    const shouldRedirectToBaseRoute = Object.keys(reservation).length === 0

    React.useEffect(() => {
        if (shouldRedirectToBaseRoute) {
            history.push(`/${language}/manage-my-booking`)
        }

        return () => {
            const newPathname = history.location.pathname.slice(3)
            if (!newPathname.includes(`/booking/${reservation.locationId}/edit/`)) {
                dispatch(clearGuestReservationsState())
            }
        }
    }, [])

    const bookingCancelledCallback = () => {
        history.push(`/${language}/manage-my-booking/cancelled`)
    }

    return <BookingDetails reservation={reservation} bookingCancelledCallback={bookingCancelledCallback} isGuest />
}

export default GuestBookingDetails
